<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Area</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item active">Area</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12" v-if="isCreate">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Add New Area</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label" for="name">Area</label>
                      <!-- <div class="input-group">
                        <span class="input-group-text" id="inputGroupPrepend"
                          >@</span
                        > -->
                      <input v-model="name" class="form-control" id="color" type="text" placeholder="Enter Area Name"
                        aria-describedby="inputGroupPrepend" required />
                    </div>

                    <div class="col-md-3">
                      <label class="form-label" for="status">Select District</label>
                      <select v-model="selectedDistrict" class="form-select" v-if="districtList.length > 0">
                        <option :key="district.id" v-for="district in districtList" :value="district.id" @change="() => {
                          this.selectedDistrict = district.id;
                        }
                          ">
                          {{ district.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <button class="btn btn-primary" type="submit" @click="addNew">
                    Add
                  </button>
                  <!-- </form> -->
                </div>
              </div>
            </div>
            <!-- Update -->
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12" v-if="!isCreate">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Update Connection</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label" for="name">Name</label>
                      <!-- <div class="input-group">
                        <span class="input-group-text" id="inputGroupPrepend"
                          >@</span
                        > -->
                      <input v-model="update.name" class="form-control" id="color" type="text"
                        placeholder="Enter Area Name" aria-describedby="inputGroupPrepend" required />
                      <!-- </div> -->
                    </div>

                    <div class="col-md-3">
                      <label class="form-label" for="status">Select District</label>
                      <select v-model="selectedDistrict" class="form-select" v-if="districtList.length > 0">
                        <option :key="district.id" v-for="district in districtList" :value="district.id" @change="() => {
                          this.selectedDistrict = district.id;
                        }
                          ">
                          {{ district.name }}
                        </option>
                      </select>
                      <!-- <div
                        class="media-body switch-md"
                        v-if="update.selectedDistrict"
                      >
                        <label class="switch">
                          <input
                            v-model="update.selectedDistrict"
                            type="checkbox"
                            checked="true"
                          /><span class="switch-state"></span>
                        </label>
                      </div> -->
                      <!-- <div
                        class="media-body switch-md"
                        v-if="!update.selectedDistrict"
                      >
                        <label class="switch">
                          <input
                            v-model="update.selectedDistrict"
                            type="checkbox"
                            checked="false"
                          /><span class="switch-state"></span>
                        </label>
                      </div> -->
                    </div>
                  </div>
                  <button class="btn btn-primary" type="submit" @click="updateTypeSubmit">
                    Update
                  </button>
                  <button class="btn btn-danger" type="submit" @click="cancelUpdate">
                    Cancel
                  </button>
                  <!-- </form> -->
                </div>
              </div>
            </div>
            <!-- Data table -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                  <span>Connection Type Status</span>
                </div>
                <div class="card-body">
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="connectionTypeTBL">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Name</th>
                          <th>District</th>
                          <th>Active Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr align="center" v-for="(item, index) in areaList" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.district_name }}</td>
                          <td>
                            <div class="media-body switch-sm" v-if="item.active_status === 1"
                              @click.prevent="changeStatus(item.id)">
                              <label class="switch">
                                <input type="checkbox" checked /><span class="switch-state"></span>
                              </label>
                            </div>
                            <div class="media-body switch-sm" v-if="item.active_status === 0"
                              @click.prevent="changeStatus(item.id)">
                              <label class="switch">
                                <input type="checkbox" /><span class="switch-state"></span>
                              </label>
                            </div>
                          </td>
                          <td>
                            <button class="btn btn-danger btn-xs" type="button"
                              data-original-title="btn btn-danger btn-xs" title="" @click.prevent="deleteType(item.id)">
                              Delete
                            </button>
                            <button class="btn btn-primary btn-xs" type="button"
                              data-original-title="btn btn-danger btn-xs" title="" @click.prevent="updateType(item)">
                              Edit
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import areaRelatedAPI from '../../../services/areaRelatedAPI.js';

import $ from 'jquery';

export default {
  name: 'areaList',
  components: {},
  data() {
    return {
      name: '',
      status: '',
      areaList: [],
      districtList: [],
      isCreate: true,
      update: {
        id: '',
        name: '',
        // active_status: '',
      },
      selectedDistrict: null,
    };
  },
  methods: {
    // district list
    getDistrictList() {
      areaRelatedAPI.districtList().then(
        response => {
          this.districtList = response.data.data;
          console.log(response.data.data);
        },
        err => {
          if (err.response.data.success === false) {
            this.districtList = [];
          }
        },
      );
    },

    // addNew
    addNew() {
      //   console.log(this.name, this.status);
      if (this.name == '') {
        this.$moshaToast('Please enter Area name', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      } else if (this.selectedDistrict == null) {
        this.$moshaToast('Please select a district', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      } else {
        let data = {
          district_id: this.selectedDistrict,
          name: this.name,
        };
        areaRelatedAPI
          .createArea(data)
          .then(response => {
            this.$moshaToast(response.data.message, {
              type: 'success',
              position: 'top-right',
              showIcon: true,
            });
            // get all connection type
            areaRelatedAPI.getList().then(response => {
              this.areaList = response.data.data;
            });
            this.name = '';
            this.selectedDistrict = null;
          })
          .catch(error => {
            console.log(error.response.data.success);
            if (error.response.data.success === false) {
              this.$moshaToast(error.response.data.message, {
                type: 'danger',
                position: 'top-right',
                showIcon: true,
              });
            }
          });
      }
    },

    // delete
    deleteType(id) {
      if (id) {
        this.$swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            areaRelatedAPI.deleteArea(id).then(response => {
              this.$moshaToast(response.data.message, {
                type: 'success',
                position: 'top-right',
                showIcon: true,
              });
              // get all connection type
              areaRelatedAPI.getList().then(response => {
                this.areaList = response.data.data;
              });
            });
          }
        });



      } else {
        this.$moshaToast('Please select connection type', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      }
    },

    // change status
    changeStatus(id) {
      if (id) {
        areaRelatedAPI.changeStatus(id).then(response => {
          this.$moshaToast(response.data.message, {
            type: 'success',
            position: 'top-right',
            showIcon: true,
          });
          // get all connection type
          areaRelatedAPI.getList().then(response => {
            this.areaList = response.data.data;
          });
        });
      } else {
        this.$moshaToast('Please select connection type', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      }
    },

    // update
    updateType(item) {
      this.isCreate = false;
      //   this.name = item.title;
      //   this.status = item.status === 1 ? true : false;
      this.id = item.id;
      // console.log(this.update);
      this.update.id = item.id;
      this.update.name = item.name;
      this.selectedDistrict = item.district_id;
    },

    // cancelUpdate
    cancelUpdate() {
      this.isCreate = true;
      this.update.id = '';
      this.update.name = '';
      this.selectedDistrict = '';
    },

    // update submit
    updateTypeSubmit() {
      if (this.update.name == '') {
        this.$moshaToast('Please enter area name', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      } else if (this.selectedDistrict == '') {
        this.$moshaToast('Please select a district', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      } else {
        // console.log(this.update);
        let data = {
          id: this.update.id,
          name: this.update.name,
          district_id: this.selectedDistrict,
        };
        areaRelatedAPI
          .updateArea(data)
          .then(response => {
            this.$moshaToast(response.data.message, {
              type: 'success',
              position: 'top-right',
              showIcon: true,
            });
            // get all connection type
            areaRelatedAPI.getList().then(response => {
              this.areaList = response.data.data;
            });
            this.isCreate = true;
            this.update.id = '';
            this.update.name = '';
            this.selectedDistrict = '';
          })
          .catch(error => {
            // console.log(error.response.data.success);
            if (error.response.data.success === false) {
              this.$moshaToast(error.response.data.message, {
                type: 'danger',
                position: 'top-right',
                showIcon: true,
              });
            }
          });
      }
    },
  },
  mounted() {
    // get District
    // this.getDistrictList();
    areaRelatedAPI.districtList().then(
      response => {
        this.districtList = response.data.data.map(e => {
          return {
            ...e,
            code: e.id,
            label: e.name,
          };
        });
      },
      err => {
        if (err.response.data.success === false) {
          this.districtList = [];
        }
      },
    );
    //   list
    areaRelatedAPI.getList().then(response => {
      this.areaList = response.data.data;
      setTimeout(() => {
        $('#connectionTypeTBL').DataTable({
          lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, 'All'],
          ],
          pageLength: 10,
          info: false,
          targets: 'no-sort',
          bSort: false,
          order: [],
          bFilter: true,
          bInfo: false,
          //   bLengthChange: false,
          bDestroy: true,
        });
      });
    });
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}
</style>
